import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {USER_TABS} from 'src/constants';
import {useAdminAccessRight} from 'src/hooks/access-rights';

import {UserConnectorLimits} from './connector-limits';
import {UserLimits} from './user-limits';

type Props = {
    userId: number,
    accountId: number,
};

export const LimitsRouter = ({userId, accountId}: Props) => {
    const {canViewUserConnectorLimits} = useAdminAccessRight();
    const isConnectorLimitsAllowed = canViewUserConnectorLimits(accountId);

    return (
        <Routes>
            <Route
                path="/limits"
                element={(
                    <UserLimits
                        userId={userId}
                        accountId={accountId}
                        isConnectorLimitsAllowed={isConnectorLimitsAllowed}
                    />
                )}
            />
            {isConnectorLimitsAllowed ? (
                <Route
                    path="/connector-limits"
                    element={<UserConnectorLimits userId={userId} accountId={accountId}/>}
                />
            ) : null}
            <Route
                path="*"
                element={<Navigate to={`/profile/user/${userId}/${USER_TABS.LIMITS.name}/limits`}/>}
            />
        </Routes>
    );
};
